import { createFeatureSelector, createSelector } from "@ngrx/store";
import { selectCategoryModelContext } from "../../context/state/context.selector";
import {
  workingCategoryFeatureKey,
  WorkingCategoryState,
} from "./working-category.reducer";

export const selectWorkingCategoryState =
  createFeatureSelector<WorkingCategoryState>(workingCategoryFeatureKey);

export const selectSandboxCategory = createSelector(
  selectWorkingCategoryState,
  (categoryContext) => {
    return categoryContext?.sandbox;
  },
);

export const selectDeltaModeState = createSelector(
  selectWorkingCategoryState,
  (categoryContext) => {
    return categoryContext?.deltaMode;
  },
);

export const selectCategoryIsReadOnly = createSelector(
  selectWorkingCategoryState,
  (categoryContext) => {
    return categoryContext?.readOnly || !categoryContext;
  },
);

export const selectCategoryModelVersionIsReadOnly = createSelector(
  selectCategoryModelContext,
  (categoryModelContext) => {
    return categoryModelContext?.readOnly || !categoryModelContext;
  },
);

export const selectGlobalSearchMatches = createSelector(
  selectWorkingCategoryState,
  (categoryContext) => {
    return categoryContext?.globalSearchMatches;
  },
);
